import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import TabNavigation from 'components/common/TabNavigation';
import BusinessTwilioCredentialsForm from 'components/settings/BusinessTwilioCredentialsForm';

import { fetchBusiness } from 'redux/modules/business';

import { appTitle, titleSeparator } from 'config/helmetSettings';

class BusinessChangeCredentials extends Component {
  componentDidMount() {
    const { actions } = this.props;
    actions.fetchBusiness({
      triggerLoading: true,
    });
  }

  render() {
    const { business, loading, account } = this.props;
    return (
      <Layout variant="settings">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Business General
          </title>
        </Helmet>
        <TabNavigation
          items={[
            {
              text: 'General',
              href: '/settings/business/general',
            },
            {
              text: 'Facilities',
              href: '/settings/business/facilities',
            },
            ...account.Roles.filter(item =>
              item.Name === 'Master Administrator' || item.Name === 'Administrator').length > 0 ?
              [
                {
                  text: 'Claim MD Credentials',
                  href: '/settings/business/claim-md-credentials',
                },
                {
                  text: 'Twilio Credentials',
                  href: '/settings/business/twilio-credentials',
                },
              ] : [],
          ]}
        />
        {loading > 0 ? (
          <Progress />
        ) : (
          <BusinessTwilioCredentialsForm
            form="businessTwilioCredentials"
            initialValues={{
              'Twilio Credentials': business['Twilio Credentials'],
            }}
          />
        )}
      </Layout>
    );
  }
}

BusinessChangeCredentials.propTypes = {
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  loading: PropTypes.number.isRequired,
  actions: PropTypes.shape({
    fetchBusiness: PropTypes.func.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
};

BusinessChangeCredentials.defaultProps = {
  business: {},
};

const mapStateToProps = store => ({
  business: store.business.data,
  loading: store.business.loading,
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchBusiness }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BusinessChangeCredentials);



// WEBPACK FOOTER //
// ./src/pages/settings/BusinessTwilioCredentials.js